<template>
    <div class="rd-scope">

      <!-- ══════════════ HERO (white) ══════════════ -->
      <section class="rd-hero">
        <div class="rd-wrap">
          <div v-if="show_eyebrow" class="rd-hero-eyebrow">{{ section_name }}</div>
          <h1 v-html="current_page['display_name']"></h1>
        </div>
      </section>

      <!-- ══════════════ PAGE BODY (sidebar + content) ══════════════ -->
      <div class="rd-page-body">

        <!-- ── SIDEBAR ── -->
        <aside class="rd-sidebar" aria-label="Section navigation">
          <template v-for="menu_item in left_menu">
            <div class="rd-side-section">
              <!-- Category node (no page_id, has children) — non-clickable header -->
              <div v-if="is_category(menu_item)" class="rd-side-hdr is-category">
                <div class="rd-side-dot"></div>
                <span v-html="menu_item.display_name"></span>
              </div>
              <!-- Standard top-level menu item — clickable -->
              <a v-else
                 href="javascript:void(0)"
                 @click="set_active(menu_item)"
                 class="rd-side-hdr"
                 :class="{ active: menu_item.page_id === $root.current_id.page }">
                <div class="rd-side-dot"></div>
                <span v-html="menu_item.display_name"></span>
              </a>
              <!-- Children -->
              <div v-if="menu_item._ref_list_children && menu_item._ref_list_children.length"
                   class="rd-side-links">
                <a v-for="sub_menu_item in menu_item._ref_list_children"
                   href="javascript:void(0)"
                   @click="set_active(sub_menu_item)"
                   :class="{ active: sub_menu_item.page_id === $root.current_id.page }"
                   v-html="sub_menu_item.display_name"></a>
              </div>
            </div>
          </template>

          <hr class="rd-side-divider">

          <div class="rd-side-contact">
            <div class="rd-side-contact-l">Need more help?</div>
            <p>Our Sydney team is available for expert advice on tax, trusts, super and AML compliance.</p>
            <a href="tel:0292315111">(02) 9231 5111</a>
            <a href="mailto:contact@macquariegs.com.au">contact@macquariegs.com.au</a>
          </div>
        </aside>

        <!-- ── CONTENT (DB-stored HTML) ── -->
        <main>
          <article class="rd-prose" v-html="current_page['content']"></article>
        </main>
      </div>

    </div>
</template>

<script>
    export default {
        name: 'ContentWithLeftMenu',
        data() {
            let current_object = this;
            let root = current_object.$root;
            let data_set = {
                current_menu_item:null,
                parent_menu_item:null,
                current_page:{
                    display_name:'Blank Resource Page',
                    content:'<p>Hello World</p>'
                },
                left_menu:[]
            };
            if (root.current_id.page && root.item_map) {
                if (root.item_map.page && root.item_map.page[root.current_id.page]) {
                    data_set.current_page = root.item_map.page[root.current_id.page];
                    if (data_set.current_page._ref_left_menu) {
                        data_set.left_menu = data_set.current_page._ref_left_menu._ref_list_children;
                        if (data_set.left_menu) {
                            data_set.left_menu.forEach(function (menu_item) {
                                if (menu_item.page_id === root.current_id.page) {
                                    data_set.current_menu_item = menu_item;
                                    data_set.parent_menu_item = menu_item;
                                } else {
                                    if (menu_item._ref_list_children) {
                                        menu_item._ref_list_children.forEach(function (sub_menu_item) {
                                            if (sub_menu_item.page_id === root.current_id.page) {
                                                data_set.current_menu_item = sub_menu_item;
                                                data_set.parent_menu_item = menu_item;
                                            }
                                        });
                                    }
                                }
                            });
                        }
                    }
                }
            }
            return data_set;
        },
        mounted() {
            $('.expandable_image_container .expand_trigger').on('click', function () {
                let expand_parent = $(this).closest('.expandable_image_container');
                let expand_wrapper = expand_parent.children('.expand_wrapper');
                if (expand_parent.hasClass('expand_parent_expanded')) {
                    expand_wrapper.animate({
                        height: 0
                    },500,function () {
                        expand_parent.removeClass('expand_parent_expanded')
                    });
                } else {
                    expand_wrapper.animate({
                        height: expand_wrapper.children('.expand_container').outerHeight()
                    },500,function () {
                        expand_parent.addClass('expand_parent_expanded')
                    });
                }
            });
        },
        computed: {
            // Derive the parent section name from the current page's pathname
            // (e.g. /client/resources/foo → "Resources").
            section_name: function () {
                let pathname = this.current_page && this.current_page.pathname ? this.current_page.pathname : '';
                // strip leading /client/ or / and take the first segment
                let parts = pathname.replace(/^\/+/, '').split('/');
                // first segment is usually 'client', second is the section slug
                let slug = parts[0] === 'client' ? (parts[1] || '') : (parts[0] || '');
                if (!slug) return '';
                let map = {
                    'resources':   'Resources',
                    'mgs-private': 'MGS Private',
                    'products':    'Products',
                    'information': 'Information'
                };
                if (map[slug]) return map[slug];
                // fall back to title-casing the slug
                return slug.replace(/-/g, ' ').replace(/\b\w/g, function (c) { return c.toUpperCase(); });
            },
            show_eyebrow: function () {
                if (!this.section_name) return false;
                if (!this.current_page || !this.current_page.display_name) return false;
                return this.current_page.display_name.toString().toLowerCase() !== this.section_name.toLowerCase();
            }
        },
        methods: {
            set_active: function (menu_item) {
                if (!menu_item.page_id && menu_item.description) {
                    location.replace(menu_item.description);
                    return;
                }
                let target_menu_item = menu_item;
                while ((!target_menu_item._ref_page || !target_menu_item._ref_page.content) && target_menu_item._ref_list_children) {
                    // Redirect to 1st child if page content is empty
                    target_menu_item = target_menu_item._ref_list_children[0];
                }

                this.$root.set_page(target_menu_item.page_id);
            },
            // Category nodes have no page_id of their own but do have children.
            // Render those as non-clickable section headers rather than as links
            // that fall through to their first child.
            is_category: function (menu_item) {
                return !menu_item.page_id
                    && menu_item._ref_list_children
                    && menu_item._ref_list_children.length;
            }
        }
    }
</script>

<style scoped>
/* page-specific tokens */
.rd-scope{color:#0a1628;background:#fff;--rd-cream:#faf6ed;--rd-off:#f5f5f5;--rd-border-lt:rgba(10,22,40,.09);--rd-gold-pale:#f5e9c8;--rd-slate:#4a5568;--rd-slate-lt:#718096;--rd-text-md:#3d5268}

/* ── HERO (white) ── */
.rd-hero{background:#fff;border-bottom:1px solid var(--rd-border-lt);position:relative;overflow:hidden;padding:54px 0 48px}
.rd-hero::before{content:'';position:absolute;inset:0;pointer-events:none;background-image:linear-gradient(rgba(223,172,93,.05) 1px,transparent 1px),linear-gradient(90deg,rgba(223,172,93,.05) 1px,transparent 1px);background-size:52px 52px;opacity:.7}
.rd-hero::after{content:'';position:absolute;width:420px;height:420px;background:radial-gradient(ellipse,rgba(223,172,93,.10) 0%,transparent 65%);top:-80px;right:5%;pointer-events:none}
.rd-hero .rd-wrap{position:relative;z-index:2}
.rd-hero-eyebrow{display:inline-flex;align-items:center;gap:8px;font-size:11px;letter-spacing:.18em;text-transform:uppercase;color:var(--rd-gold);margin-bottom:12px;font-weight:700}
.rd-hero-eyebrow::before{content:'';display:block;width:20px;height:1px;background:var(--rd-gold)}
.rd-hero h1{font-size:38px;font-weight:800;color:var(--rd-navy);letter-spacing:-.01em;line-height:1.15;margin:0}

/* ── PAGE BODY: 2-col grid ── */
.rd-page-body{padding:44px 32px;display:grid;grid-template-columns:260px 1fr;gap:44px;align-items:start;max-width:1180px;margin:0 auto}

/* ── SIDEBAR ── */
.rd-sidebar{position:static}
.rd-side-section{margin-bottom:6px}
.rd-side-hdr{display:flex;align-items:center;gap:8px;padding:10px 14px;font-size:11.5px;letter-spacing:.14em;text-transform:uppercase;color:var(--rd-navy);font-weight:700;border-radius:3px;transition:background .15s;background:var(--rd-cream);text-decoration:none !important;cursor:pointer}
.rd-side-hdr:not(.is-category):hover{background:#f0eadd;color:var(--rd-navy)}
.rd-side-hdr.active{background:var(--rd-gold-pale);color:var(--rd-navy)}
.rd-side-hdr.is-category{cursor:default;background:transparent;color:var(--rd-slate-lt);font-size:10.5px;letter-spacing:.18em;padding:14px 14px 6px}
.rd-side-hdr.is-category .rd-side-dot{background:var(--rd-gold)}
.rd-side-dot{width:8px;height:8px;border-radius:50%;background:var(--rd-gold);flex-shrink:0}
.rd-side-links{display:flex;flex-direction:column;padding:6px 0 12px 22px;gap:1px}
.rd-side-links a{display:block;font-size:13px;color:var(--rd-slate);padding:6px 12px;border-radius:3px;transition:all .15s;line-height:1.45;cursor:pointer}
.rd-side-links a:hover{color:var(--rd-navy);background:var(--rd-cream)}
.rd-side-links a.active{color:var(--rd-navy);background:var(--rd-gold-pale);font-weight:600}
.rd-side-divider{border:none;border-top:1px solid var(--rd-border-lt);margin:14px 0}
.rd-side-contact{background:var(--rd-navy);border-radius:8px;padding:20px;margin-top:18px}
.rd-side-contact-l{font-size:10px;letter-spacing:.16em;text-transform:uppercase;color:var(--rd-gold-lt);font-weight:700;margin-bottom:10px}
.rd-side-contact p{font-size:12px;color:rgba(255,255,255,.65);line-height:1.6;margin-bottom:14px}
.rd-side-contact a{display:block;font-size:13px;color:var(--rd-gold-lt);margin-bottom:5px;font-weight:600}
.rd-side-contact a:hover{color:#fff}

/* ── PROSE (DB-stored HTML content) ── */
.rd-prose{font-size:15.5px;color:#1f2a37;line-height:1.78;max-width:780px}
.rd-prose >>> *:first-child{margin-top:0}
.rd-prose >>> *:last-child{margin-bottom:0}

.rd-prose >>> h2{font-size:26px;font-weight:800;color:var(--rd-navy);margin:38px 0 14px;line-height:1.22;letter-spacing:-.01em;padding-bottom:10px;border-bottom:1px solid var(--rd-border-lt)}
.rd-prose >>> h3{font-size:20px;font-weight:700;color:var(--rd-navy);margin:30px 0 12px;line-height:1.3;letter-spacing:-.005em}
.rd-prose >>> h3:first-child{margin-top:0}
.rd-prose >>> h4{font-size:16px;font-weight:700;color:var(--rd-navy);margin:24px 0 10px;line-height:1.35}
.rd-prose >>> h5{font-size:14px;font-weight:700;color:var(--rd-navy);margin:20px 0 8px;text-transform:uppercase;letter-spacing:.06em}

.rd-prose >>> p{margin:0 0 16px}
.rd-prose >>> p:empty{display:none}

.rd-prose >>> a{color:var(--rd-gold);font-weight:600;text-decoration:underline;text-decoration-color:rgba(223,172,93,.4);text-underline-offset:3px}
.rd-prose >>> a:hover{color:#c79744;text-decoration-color:var(--rd-gold)}

.rd-prose >>> strong,.rd-prose >>> b{color:var(--rd-navy);font-weight:700}
.rd-prose >>> em,.rd-prose >>> i{font-style:italic}

.rd-prose >>> ul,.rd-prose >>> ol{margin:0 0 18px;padding-left:24px}
.rd-prose >>> ul li,.rd-prose >>> ol li{margin-bottom:8px;line-height:1.7}
.rd-prose >>> ul li::marker{color:var(--rd-gold)}
.rd-prose >>> ul ul,.rd-prose >>> ol ol,.rd-prose >>> ul ol,.rd-prose >>> ol ul{margin:8px 0 8px}

.rd-prose >>> img{max-width:100%;height:auto;border-radius:4px;margin:18px 0;border:1px solid var(--rd-border-lt)}

.rd-prose >>> hr{border:none;border-top:1px solid var(--rd-border-lt);margin:30px 0}

.rd-prose >>> blockquote{border-left:4px solid var(--rd-gold);background:var(--rd-cream);padding:16px 22px;margin:20px 0;font-style:italic;color:#1f2a37;border-radius:0 4px 4px 0}
.rd-prose >>> blockquote p{margin:0}

.rd-prose >>> table{width:100%;border-collapse:collapse;margin:22px 0;font-size:14px}
.rd-prose >>> table th{background:var(--rd-navy);color:#fff;padding:11px 14px;text-align:left;font-size:11.5px;letter-spacing:.06em;text-transform:uppercase;font-weight:700}
.rd-prose >>> table td{padding:11px 14px;border-bottom:1px solid var(--rd-border-lt);vertical-align:top;line-height:1.6}
.rd-prose >>> table tr:nth-child(even) td{background:#f8f7f3}
.rd-prose >>> table tr:hover td{background:var(--rd-cream)}

.rd-prose >>> code{font-family:Consolas,Monaco,'Courier New',monospace;font-size:.92em;background:var(--rd-off);padding:2px 6px;border-radius:3px;border:1px solid var(--rd-border-lt);color:var(--rd-navy)}
.rd-prose >>> pre{background:var(--rd-off);border:1px solid var(--rd-border-lt);border-radius:4px;padding:14px 18px;overflow-x:auto;margin:20px 0}
.rd-prose >>> pre code{background:none;border:none;padding:0}

/* ── LEGACY CONTENT CLASSES (used inside DB-stored HTML) ──── */

/* example_container — used 83x across resources pages */
.rd-prose >>> .example_container{
  background:var(--rd-cream);
  border:1px solid #ecd9a4;
  border-left:4px solid var(--rd-gold);
  border-radius:0 6px 6px 0;
  padding:20px 26px;
  margin:24px 0;
  text-align:left;
}
.rd-prose >>> .example_container > *:first-child{margin-top:0}
.rd-prose >>> .example_container > *:last-child{margin-bottom:0}
.rd-prose >>> .example_container h3,
.rd-prose >>> .example_container h4{
  font-size:11px;
  font-weight:700;
  letter-spacing:.18em;
  text-transform:uppercase;
  color:var(--rd-gold);
  margin:0 0 12px;
  padding:0;
  border:none;
}
.rd-prose >>> .example_container ul,
.rd-prose >>> .example_container ol{margin:8px 0 12px;padding-left:22px}
.rd-prose >>> .example_container ul li::marker{color:var(--rd-gold)}

/* highlight_text — inline gold emphasis */
.rd-prose >>> .highlight_text{color:var(--rd-gold);font-weight:700}

/* highlight_title — bigger gold/navy heading */
.rd-prose >>> .highlight_title{
  color:var(--rd-navy);
  font-size:1.25em;
  font-weight:700;
  display:block;
  margin:0 0 10px;
}

/* column_wrapper / column_container — multi-column content layouts */
.rd-prose >>> .column_wrapper{display:grid;grid-template-columns:1fr 1fr;gap:28px;margin:20px 0;align-items:start}
.rd-prose >>> .column_wrapper.column_wrapper_3{grid-template-columns:1fr 1fr 1fr}
.rd-prose >>> .column_container{min-width:0}
.rd-prose >>> .column_container > *:first-child{margin-top:0}
.rd-prose >>> .column_container > *:last-child{margin-bottom:0}
.rd-prose >>> .column_title{font-size:17px;font-weight:700;color:var(--rd-navy);margin:0 0 10px}
.rd-prose >>> .column_content{font-size:14.5px;color:var(--rd-text-md);line-height:1.7}
.rd-prose >>> .column_thumb,
.rd-prose >>> .image_container img{max-width:100%;height:auto;border-radius:4px;border:1px solid var(--rd-border-lt)}
@media(max-width:680px){
  .rd-prose >>> .column_wrapper,
  .rd-prose >>> .column_wrapper.column_wrapper_3{grid-template-columns:1fr}
}

/* expand_* family — legacy collapsible sections */
.rd-prose >>> .expand_parent{
  background:#fff;
  border:1px solid var(--rd-border-lt);
  border-radius:4px;
  margin:14px 0;
  overflow:hidden;
}
.rd-prose >>> .expand_trigger{
  padding:14px 18px;
  font-weight:700;
  color:var(--rd-navy);
  background:var(--rd-cream);
  cursor:pointer;
  border-bottom:1px solid var(--rd-border-lt);
  display:flex;
  align-items:center;
  gap:10px;
}
.rd-prose >>> .expand_trigger .glyphicon{font-size:.85em;color:var(--rd-gold)}
.rd-prose >>> .expand_wrapper{display:block}
.rd-prose >>> .expand_container{padding:16px 20px}
.rd-prose >>> .expand_container > *:first-child{margin-top:0}
.rd-prose >>> .expand_container > *:last-child{margin-bottom:0}
.rd-prose >>> .expand_container .highlight_title{color:var(--rd-navy);font-size:1.15em}

/* expandable_image_container — image with caption */
.rd-prose >>> .expandable_image_container{margin:18px 0;text-align:center}
.rd-prose >>> .expandable_image_container img{max-width:100%;height:auto;border-radius:4px;border:1px solid var(--rd-border-lt)}

/* section_content_row — content rows */
.rd-prose >>> .section_content_row{margin:14px 0}

/* standout_text — large emphasis */
.rd-prose >>> .standout_text{
  display:block;
  font-size:1.4em;
  font-weight:700;
  color:var(--rd-navy);
  padding:14px 0;
  border-top:1px solid var(--rd-border-lt);
  border-bottom:1px solid var(--rd-border-lt);
  margin:20px 0;
  text-align:center;
}

/* responsive */
@media(max-width:980px){
  .rd-page-body{grid-template-columns:1fr;gap:32px;padding:32px 24px}
  .rd-hero{padding:42px 0 36px}
  .rd-hero h1{font-size:30px}
}
</style>
